export interface PublicCouponLike {
  id: number;
  couponCode?: string;
  couponType?: string;
  discount?: number;
  minAmount?: number;
  description?: string;
  orderType?: string;
}

export function formatCouponBadge(coupon: PublicCouponLike, currencySymbol = ''): string {
  if (coupon.couponType?.toUpperCase() === 'PERCENT' && coupon.discount != null) {
    return `${Math.round(coupon.discount)}% OFF`;
  }
  if (coupon.discount != null) {
    return `${currencySymbol}${Math.round(coupon.discount)} OFF`;
  }
  return coupon.couponCode || 'DEAL';
}

export function formatCouponText(
  coupon: PublicCouponLike,
  formatPrice?: (amount: number) => string
): string {
  const code = coupon.couponCode ? `Use code ${coupon.couponCode}` : 'Coupon offer';
  const min = coupon.minAmount && formatPrice
    ? ` on orders above ${formatPrice(Math.round(coupon.minAmount))}`
    : '';
  const desc = coupon.description?.trim();
  return desc || `${code}${min}`;
}

export function couponMatchesOrderType(
  couponOrderType: string | undefined,
  orderType: number
): boolean {
  const type = (couponOrderType || 'ALL').toUpperCase();
  if (type === 'ALL') {
    return true;
  }
  if (type === 'DINE_IN') {
    return orderType === 1;
  }
  if (type === 'DELIVERY') {
    return orderType === 2;
  }
  if (type === 'TAKEAWAY') {
    return orderType === 3;
  }
  return true;
}

export function formatPromotionText(promotion: {
  name: string;
  description?: string;
  discountPreview?: string;
}): string {
  if (promotion.discountPreview) {
    return `${promotion.name} - ${promotion.discountPreview}`;
  }
  if (promotion.description) {
    return `${promotion.name} - ${promotion.description}`;
  }
  return promotion.name;
}
